import s from './styles.module.scss';

import type { FC } from 'react';

interface InfoBlockProps {
  label: string;
  value: string;
}

const InfoBlock: FC<InfoBlockProps> = ({ label, value }) => {
  return (
    <div className={s['info-block']}>
      <p className={s['info-block-label']}>{label}</p>
      <p className={s['info-block-value']}>{value}</p>
    </div>
  );
};
export default InfoBlock;
